module.exports = __webpack_public_path__ + "a8ca896de69b4144a3f6d378d604b9df.jpg";